module.exports = ".ellipsis {\n    max-width: 40px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}"